export default "__VITE_ASSET__4cd7fc8d__"